import { setUser } from '@sentry/browser';

const UNDEFINED_USER = 'undefined-user';

export function setSentryUser(email: string): void {
  const user = email ? { email } : { username: UNDEFINED_USER };
  setUser(user);
}
